import {Services} from "../../config";
import {callService} from "../../data.service";
import {Base} from "./Base";
import {environment} from '../../../environments/environment';

export class User extends Base{
  username: string;
  roleDisplay: string;
  groupsMosaico: string;

  role: string;
  groups:any[];
  firstName: any;
  lastName: any;
  thumbnail: any;

  constructor(args) {
    super(args);
    this.roleDisplay = this.isAdmin() ? "ADMIN" : "USER";
    this.groupsMosaico = this.setGroupsMosaico();
    if(!this.username) return null;
  }

  public isAdmin(){
    return this.role === 'org_admin' || this.role === 'org_publisher';
  }

  public setGroupsMosaico(){
    let configUser = environment.userInfo;
    if(this.isAdmin()){
      let found = this.groups.filter(function(item){ return item.title === configUser.adminGroup});
      if(found && found.length){
        return configUser.adminGroup;
      }
    }else{
      let found = this.groups.filter(function(item){
        return item.title.indexOf(configUser.groupPermissionPart) !== -1 && item.title !== configUser.uploadGroup;
      });
      if(found && found.length){
        return found[0].title;
      }
    }
    return "";

  }

}

export class UserLogIn {
  user: User;

  constructor(token) {
    this.setUser(token);
  }

  public getUser():User{
    return this.user;
  }

  public setUser(token){
    let that = this;

    let userDataJson = sessionStorage.getItem("user");
    if(userDataJson){
      this.user = new User(JSON.parse(userDataJson));
    }else{
      this.user = null;
    }

    if(this.user && token){
      Services.self.params.token = token;
      callService(Services.self).done(function( resultsSelf ) {
        if(resultsSelf && resultsSelf.hasOwnProperty("access")){
          sessionStorage.setItem("user", JSON.stringify(resultsSelf));
          that.user = new User(resultsSelf);
        }else{
          that.user = null;
          if(location.href.indexOf("/login") === -1) location.href = "/login";
        }
      });
    }

  }

}
